/* eslint-disable */
/**
 * Ce fichier permets de revoir la trace dans la map statique
 * © Moustapha HENNAWI - Click and Take off - 2021
 */
/*-------------------------------------------------------------------------------------------*/
import 'mapbox-gl/dist/mapbox-gl.css';
import mapboxgl from 'mapbox-gl';
import PropTypes from 'prop-types';

import { useEffect, useState } from 'react';

import { map, tb } from './Map';

import PlaneModels from '../resources/images/models/plane.glb';
import { mapFitBound } from './mapUtil';

// ----------------------------------------------------------------------
const MAP_HANDLER = ['boxZoom', 'scrollZoom', 'dragPan'];

const api = {
  fixedZoom: true,
  pan: true,
  maxZoom: 16
};
// ----------------------------------------------------------------------
ReplayPathMap3dShare.propTypes = {
  state: PropTypes.object,
  setState: PropTypes.func,
  setIndexDisplay: PropTypes.func
};
export default function ReplayPathMap3dShare({ state, setState, setIndexDisplay }) {
  const positions = state.positions;
  const [plane, setPlaneModel] = useState();
  const coordinates = (() => {
    const coordinates = [];
    for (let i = 0; i < positions.length; i += 2) {
      coordinates.push([positions[i].longitude, positions[i].latitude, positions[i].altitude]);
    }
    return coordinates;
  })();

  const mapConfig = {
    MAD: {
      origin: [
        positions[0].longitude,
        positions[0].latitude,
        positions[0].elevation !== undefined && positions[0].altitude - positions[0].elevation < 0
          ? positions[0].elevation
          : positions[0].altitude
      ],
      originCourse: positions[0].course,
      destination: [
        positions[positions.length - 1].longitude,
        positions[positions.length - 1].latitude,
        positions[positions.length - 1].elevation !== undefined &&
        positions[positions.length - 1].altitude - positions[positions.length - 1].elevation < 0
          ? positions[positions.length - 1].elevation
          : positions[positions.length - 1].altitude
      ],
      center: [
        positions[0].longitude,
        positions[0].latitude,
        positions[0].elevation !== undefined && positions[0].altitude - positions[0].elevation < 0
          ? positions[0].elevation
          : positions[0].altitude
      ],
      current: [
        positions[state.currentPosition].longitude,
        positions[state.currentPosition].latitude,
        positions[state.currentPosition].elevation !== undefined &&
        positions[state.currentPosition].altitude - positions[state.currentPosition].elevation < 0
          ? map.queryTerrainElevation(
              [
                positions[state.currentPosition].longitude,
                positions[state.currentPosition].latitude
              ],
              { exaggerated: true }
            )
          : positions[state.currentPosition].altitude
      ],
      zoom: 20,
      pitch: 50,
      bearing: -13,
      scale: 0.1,
      timezone: 'Europe/Madrid'
    },
    names: {
      customLayer: 'custom-layer'
    }
  };

  function animate() {
    requestAnimationFrame(animate);
  }

  function init() {
    animate();
  }

  const onObjectChanged = async (e) => {
    if (state.playVol) {
      const model = e.detail.object; // here's the object already modified
      const positionIndex = positions.indexOf(
        positions.find(
          (item) =>
            item.longitude > model.coordinates[0] - 0.002 &&
            item.longitude < model.coordinates[0] + 0.002 &&
            item.latitude > model.coordinates[1] - 0.001 &&
            item.latitude < model.coordinates[1] + 0.001
        )
      );

      if (positionIndex !== -1) {
        const position = [model.coordinates[0], model.coordinates[1]];
        const altitude = model.coordinates[2] + 100;

        const camera = map.getFreeCameraOptions();
        camera.position = mapboxgl.MercatorCoordinate.fromLngLat(position, altitude);
        camera.lookAtPoint([model.coordinates[0], model.coordinates[1]]);
        camera.setPitchBearing(80, positions[positionIndex].course);
        map.setFreeCameraOptions(camera);

        map.setPitch(80);
        map.setBearing(positions[positionIndex].course);
        if (altitude > 350) {
          map.setZoom(map.getZoom() - 0.25);
        } else if (altitude > 260 && altitude < 350) {
          map.setZoom(map.getZoom() - 0.4);
        } else {
          map.setZoom(map.getZoom() - 0.6);
        }

        setIndexDisplay(positionIndex);
      }
    }

    tb.map.repaint = true;
  };

  function fly() {
    if (
      coordinates !== null &&
      coordinates !== undefined &&
      plane !== null &&
      plane !== undefined
    ) {
      // extract path geometry from callback geojson, and set duration of travel
      const options = {
        path: coordinates,
        duration: 800000 / state.speedReplay
      };
      // start the truck animation with above options, and remove the line when animation ends
      plane.followPath(options, () => {
        plane.stop();
        plane.setCoords(mapConfig.MAD.origin);
        plane.setRotation({ x: 0, y: 0, z: 180 - mapConfig.MAD.originCourse });
        map.flyTo({
          center: mapConfig.MAD.origin,
          pitch: 0,
          bearing: 0,
          zoom: 20
        });
        setState({ ...state, playVol: false });
      });
    }
  }

  function createLine(coordinate, name, color) {
    if (coordinate !== null && coordinate !== undefined) {
      const line = tb.line({
        geometry: coordinate,
        width: 8,
        color
      });

      tb.add(line, name);
    }
  }

  /** ***************************************************************************************************************************************************************** */
  useEffect(() => {
    init();
    map.addLayer({
      id: 'custom_layer',
      type: 'custom',
      renderingMode: '3d',
      onAdd: (map, mbxContext) => {
        // Creative Commons License attribution: Plane model by https://sketchfab.com/ideehochzwei
        // from  https://sketchfab.com/3d-models/plane-aa001f5a88f64b16b98356c042f2d5f3
        let planeload;

        tb.altitudeStep = 1;

        const options = {
          obj: PlaneModels,
          type: 'gltf',
          scale: mapConfig.MAD.scale,
          rotation: { x: 90, y: 0, z: 0 },
          anchor: 'center',
          bbox: false,
          clone: false
        };

        if (api.fixedZoom) options.fixedZoom = api.maxZoom;

        tb.loadObj(options, async (model) => {
          planeload = model.setCoords(mapConfig.MAD.origin);
          setPlaneModel(planeload);
          planeload.setRotation({
            x: 0,
            y: 0,
            z: 180 - mapConfig.MAD.originCourse
          });
          planeload.addEventListener('ObjectChanged', onObjectChanged, false);
          planeload.castShadow = true;
          tb.add(planeload);
          tb.map.repaint = true;
          /** *************************************************************************** Create line */
          createLine(coordinates, 'Line', '#22398d');
          mapFitBound(coordinates);
        });
      },
      render: () => {
        tb.update();
      }
    });

    return () => {
      if (plane !== undefined) {
        plane.stop();
      }
      tb.clear();
      if (map.getLayer('custom_layer')) {
        map.removeLayer('custom_layer');
      }
    };
  }, []);

  useEffect(() => {
    if (plane !== undefined && plane !== null) {
      plane.setCoords([
        positions[state.currentPosition].longitude,
        positions[state.currentPosition].latitude,
        positions[state.currentPosition].elevation !== undefined &&
        positions[state.currentPosition].altitude - positions[state.currentPosition].elevation < 0
          ? map.queryTerrainElevation(
              [
                positions[state.currentPosition].longitude,
                positions[state.currentPosition].latitude
              ],
              { exaggerated: true }
            )
          : positions[state.currentPosition].altitude
      ]);
      plane.setRotation({
        x: 0,
        y: 0,
        z: 180 - positions[state.currentPosition].course
      });
    }
  }, [state.currentPosition]);

  useEffect(() => {
    if (plane !== undefined && plane !== null) {
      plane.addEventListener('ObjectChanged', onObjectChanged, false);

      if (state.playVol) {
        MAP_HANDLER.forEach((h) => (h = map[h]) && h.enable && h.disable && h.disable());
        const planeAltitude = plane.coordinates[2];
        const dynamicZoom =
          planeAltitude <= 150 ? 18 : planeAltitude >= 300 ? 14 : -(1 / 37.5) * planeAltitude + 22; // y = -1/37.5x + 22

        map.easeTo({
          pitch: 70,
          bearing: 20,
          center: mapConfig.MAD.origin,
          zoom: dynamicZoom,
          easing(t) {
            if (t === 1) {
              fly();
            }
            return t;
          }
        });
      } else {
        MAP_HANDLER.forEach((h) => (h = map[h]) && h.enable && h.disable && h.enable());
        plane.stop();
        plane.setCoords(mapConfig.MAD.origin);
        plane.setRotation({ x: 0, y: 0, z: 180 - mapConfig.MAD.originCourse });
      }
    }
  }, [state.playVol]);

  return null;
}
